module.exports = OpenHPS.video;